// 导入Unocss
import 'virtual:uno.css'
import 'element-plus/theme-chalk/src/message.scss'
import 'element-plus/dist/index.css'
import './utils/promise-polyfill'

import { createApp } from 'vue'
import App from './App.vue'
import { setupAssets, setupScrollbarStyle } from './plugins'
import directives from './directive' // 自定义指令
import posthogPlugin from './plugins/posthog' // import the plugin.
import { setupI18n } from './locales'
import { setupRouter } from './router'
import { setupStore } from './store'
import { getPosthogPath } from '@/utils/tool' // 埋点page-actions文案
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

async function bootstrap() {
  const app = createApp(App)

  if (import.meta.env.VITE_APP_EVN_ON === 'true') {
    app.use(posthogPlugin)
  } // install the plugin

  app.use(ElementPlus, {
    locale: zhCn,
  })

  setupAssets()

  setupScrollbarStyle()

  setupStore(app)

  setupI18n(app)

  await setupRouter(app)

  /**
   * 全局注册配置(test 可以用$getPosthogPath但是会有ts爆红)
   */
  app.config.globalProperties.$getPosthogPath = getPosthogPath

  app.use(directives) // 自定义指令
  app.mount('#app')

  // window.addEventListener('storage', (e) => {
  //   // 切换workspace后，刷新其他标签页 // todo 单独设置一个key
  //   if (e.key === 'userStorage') {
  //     // reload
  //     window.location.reload()
  //   }
  // })
}

bootstrap()
